import React  from 'react';
import { Box, Modal } from '@mui/material';
import classes from '../modal.module.scss';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { closeModal } from '../../../store/modal/reducer';
import {ITransactionInputForm} from '../TransactionInput/TransactionInputForm';
import { UpdateInputTransactionForm } from './UpdateInputTransactionForm';
import {updateInputTransaction} from '../../../store/input-transaction/thunk';

export interface UpdateTransactionInputForm extends Omit<ITransactionInputForm, 'clientId' | 'type' | 'payment'>{
    payment: number | null;
    id: number;
    paymentInfo: {
        id: number;
    }
}

export const UpdateInputTransaction: React.FC = () =>{
    const dispatch = useAppDispatch();
    const { isLoading } = useAppSelector(state => state.client);
    const { data } = useAppSelector(state => state.modal);

    const onCloseModal = () => dispatch(closeModal());

    const onSubmit = (formData: UpdateTransactionInputForm) => {
        dispatch(updateInputTransaction({...formData, payment: Number(formData.payment)}));
    };

    return (
        <Modal
            sx={{
                position:'absolute',
                overflow:'auto',
                height:'100%',
            }}
            open={true}
            className={classes.container}
        >
            <Box
                className={classes.wrapper}
                sx={{
                    position: 'inherit',
                    marginTop: 8,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                <UpdateInputTransactionForm
                    onCancel={onCloseModal}
                    onSubmit={onSubmit}
                    inputTransactionData={data.transaction}
                    isLoading={isLoading}
                />

            </Box>
        </Modal>
    );
};
